export { default, type Route } from './redux-router';
